import * as i0 from "@markdoc/markdoc";
import * as i1 from "xregexp";
import * as i2 from "react-dom";
import * as i3 from "highlight.js/lib/languages/json";
import * as i4 from "tweetnacl-util";
import * as i5 from "highlight.js/lib/highlight";
import * as i6 from "highlight.js/lib/languages/xml";
import * as i7 from "highlight.js/lib/languages/clojure";
import * as i8 from "ladder/agents/dashboard/hello";
import "raf/polyfill";
import * as i9 from "react-dom/server";
import * as i10 from "raven-js";
import * as i11 from "tweetnacl";
import * as i12 from "tweetnacl-sealedbox-js";
import * as i13 from "react";
import * as i14 from "react-select";
import * as i15 from "react-transition-group";
import * as i16 from "react-css-transition-replace";
import * as i17 from "clipboard";
import * as i18 from "prop-types";

const ALL = {};

globalThis.shadow$bridge = function(name) {
  const ret = ALL[name];
  if (ret == undefined) {
    throw new Error("Dependency: " + name + " not provided by external JS!");
  } else {
    return ret;
  }
};

ALL["@markdoc/markdoc"] = i0;

ALL["xregexp"] = i1;

ALL["react-dom"] = i2;

ALL["highlight.js/lib/languages/json"] = i3;

ALL["tweetnacl-util"] = {
  decodeBase64: i4.decodeBase64,
  decodeUTF8: i4.decodeUTF8,
  encodeBase64: i4.encodeBase64,
  encodeUTF8: i4.encodeUTF8
};

ALL["highlight.js/lib/highlight"] = i5;

ALL["highlight.js/lib/languages/xml"] = i6;

ALL["highlight.js/lib/languages/clojure"] = i7;

ALL["ladder/agents/dashboard/hello"] = {
  hello: i8.hello
};

ALL["raf/polyfill"] = {

};

ALL["react-dom/server"] = i9;

ALL["raven-js"] = i10;

ALL["tweetnacl"] = {
  box: i11.box,
  secretbox: i11.secretbox,
  randomBytes: i11.randomBytes
};

ALL["tweetnacl-sealedbox-js"] = {
  seal: i12.seal,
  open: i12.open
};

ALL["react"] = i13;

ALL["react-select"] = i14;

ALL["react-transition-group"] = i15;

ALL["react-css-transition-replace"] = i16;

ALL["clipboard"] = i17;

ALL["prop-types"] = i18;
